import React, {useState} from "react";
import Link from "next/link";
import {useStore} from "../../context/state";
import { Content as PricvacyPolicyContent } from "../PrivacyPolicy/Content";
import { Content as TermsAndConditionsContent } from "../TermsAndConditions/Content";
import { CookiePolicy } from "./CookiePolicy";
import { ReturnPolicy } from "./ReturnPolicy";
import { DataPolicy } from "./DataPolicy";

import { SubMenu } from "../../components/SubMenu";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { useRouter } from "../../hooks/useRouter";

export const Page = () => {
  const { isMobile } = useStore();
  const router = useRouter();
  const pathname = router.pathname


    const renderContent = () => {
        if (pathname.includes("/policy-center/privacy-policy") || pathname === "/policy-center/" || pathname === "/policy-center") {
            return <PricvacyPolicyContent/>;
        } else if (pathname.includes("/policy-center/terms-and-conditions")) {
            return <TermsAndConditionsContent/>;
        } else if (pathname.includes("/policy-center/cookie-policy")) {
            return <div className="u-flexCenter u-justifyContentCenter"><CookiePolicy/></div>;
        } else if (pathname.includes("/policy-center/refund-policy")) {
            return <div className="u-flexCenter u-justifyContentCenter"><ReturnPolicy/></div>;
        } else if (pathname.includes("/policy-center/data-policy")) {
          return <div className="u-flexCenter u-justifyContentCenter"><DataPolicy/></div>;
        }
        return null;
    };

  return (
    <div className="background-wrapper">
      <div className="container u-xs-padding0">
        <div className="paper-box u-paddingLeft80 u-paddingRight80 u-xs-paddingHorizontal24">
          <SubMenu />
          <span className="u-textColorPrimary u-fontSize28 u-fontWeightBold">
            Policy Center
          </span>
          <div className="u-marginTop10 u-paddingBottom8 u-borderBottom1 u-borderColorLighter">
            <Breadcrumbs className=" u-textColorDarker" aria-label="breadcrumb">
              <Link href="/" color="inherit" className="u-cursorPointer">
                Home
              </Link>
              <Typography color="textPrimary">Policy Center</Typography>
            </Breadcrumbs>
          </div>
          <div className="u-marginTop10 u-paddingBottom50">
              <div className="u-sizeFullWidth u-flexCenter u-justifyContentCenter">
                  <ButtonGroup variant="outlined" orientation={isMobile ? "vertical" : "horizontal"} className="u-noWrap u-height38 u-marginVertical12" aria-label="contained primary button group">
                      {
                          [
                              {name: "Privacy Policy", link: "/policy-center"},
                              {name: "Terms & Conditions", link: "/policy-center/terms-and-conditions"},
                              {name: "Cookie Policy", link: "/policy-center/cookie-policy"},
                              {name: "Refund Policy", link: "/policy-center/refund-policy"},
                              {name: "Opt Out", link: "/policy-center/data-policy"},
                          ].map((v, i) => {
                            
                            const isSelected = pathname.endsWith(v.link);
                            console.log("v", v);
                            console.log("i", isMobile);
                            return (
                              
                              <Button key={i}
                              color={isSelected ? "secondary" : undefined}
                              className={isSelected ? "  " : "u-opacity60"}
                                size="large" onClick={() => router.push(v.link)}
                                >
                                
                          {v.name}
                      </Button>
                              );
                          })
                      }
                  </ButtonGroup>
              </div>

              <div className="u-marginTop30">
                  {renderContent()}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};
